const $variables = require('./variables');
const $functions = require('./functions');
const writtenNumber = require('written-number');
const $vars = $variables.vars;
const $grades = $variables.grades;
const $operations = $variables.operations;
const $operators = $variables.operators;
const $params = $variables.params;
const hash = require('object-hash');
const converter = require('number-to-words-en');
const signs = $variables.signs;
import RulesVarsProperties from './rules-vars-properties';
let operat;

const Fraction = require('./Fraction');
let comparators = $variables.comparators,
    comparators_values = Object.values(comparators).map(el => el.val), joiners = $variables.joiners.map(el => el.value);

class Variable {
    constructor(vable, level, id_practice = -1){
        let v = Object.assign({
            type: '',
            constraints: '',
            varName: 'var',
            precision: 0,
            rules: ""
        }, vable);
        if (v.diff == null) v.exp = '';
        if (v.type == null) v.type = '';
        if (v.constraints == null) v.constraints = '';
        if (v.rulesObject == null) v.rulesObject = "";

        this.name = v.varName;
        for (let key in v) {
            this[key] = v[key];
        }

        this.rulesObject = {};
        /**
         * Generate rulesObject object based on rulesObject
         * @param  {String} let obj           of this.rulesObject.split('##') Split contraintsRules string to generate exploitable Object
         * @return {Object}     Object of key: value pairs
         *
         * for the key and value pair on the main object, we will use key@value where value is a json string(Object, Array, Boolean, Number, String)
         * Separate each key-value pair with ## for the direct properties of main object: key_1@value_1##key_2@value_2##...##key_n@value_n
         *
         * Ex: 'contains@2##exclude@{"number":"23", "array": ["item1", true, 25, ["nested array", {"nested": "object"}]]}##"after-object"@"value after object"'
         * will generate the following object
         * { contains: 2, exclude: { number: "23", array: ["item1", true, 25, ["nested array", { nested: "object" }]] }, "after-object": "value after object" }
         *
         */
        for (let obj of v.rules.split('##').filter(el => el.trim().length > 0)) {
            let arr_obj = obj.split("@");
            if (arr_obj[0].trim().length == 0) continue;
            if (arr_obj.length < 2) arr_obj.push(null);
            this.rulesObject[arr_obj[0]] = JSON.parse(arr_obj[1]);
        }

        this.id_practice = id_practice;
        if(v.type.includes('float')) {
            this.type = 'float';
            this.precision = $functions.alt(v.type.slice(v.type.indexOf(':') + 1), 2);
            this.isFloat = true;
        }

        if (!this.hasOwnProperty('value')) {
            this.value = this.calculate_val(level);
        }
    }
    calculate_val(level) {
        let type = $functions.alt(this.type, this.name.trim().replace(/(\d|-|_)+(.)*/g,'')), cons = this.constraints.toString();
        let l = cons.indexOf(':'), funct = l > 0 ? cons.slice(0,l) : '', res,
            val = l > 0 ? cons.slice(l + 1) : cons;
        if(funct === 'in'){
            res = val.split("||").getRand();
            switch (type) {
                case 'fract': return new Fraction(res); break;
                case 'int': return parseInt(eval_exp(res)); break;
                case 'float': return Number(eval_exp(res)).toFixed(this.precision); break;
                default:
                    return res;
                    break;
            }
        }
        switch (type) {
            case 'int':
                return this.evaluate_int(cons, level);
                break;
            case 'float':
                return this.evaluate_int(cons, level);
                break;
            case 'cond':
                return this.evaluate_condition(cons);
                break;
            case 'fract':
                return this.evaluate_fract(cons);
                break;
            default:
                let tab = $vars[type] || [];
                if(tab.length < 1){
                    return cons;
                }
                switch (funct) {
                    case 'index':
                        let index = parseInt(eval_exp(val)), l = $vars[type].length;
                        return $vars[type][(index + l) % l];
                        break;
                    default:
                        return tab.getRand();
                        break;
                }
        }
    }
    /**
     * Compute a variabkle value based on constraints provided
     * @param  {String} cons  constraints string to compute
     * @param  {Number} level Level of the practice
     * @return {Number}       [description]
     */
    evaluate_int(cons, level){
        let funct = cons.includes(":") ? cons.slice(0, cons.indexOf(':')) : '',
            val = cons.slice(cons.indexOf(':') + 1), res, precision = this.precision,
            isExclude, isInclude;
        do {
            switch (funct) {
                case 'gt':
                val = this.isFloat ? parseFloat(eval_exp(val)) + (1 / Math.pow(10, precision - 1)) : parseInt(eval_exp(val)) + 1;
                res = $functions.rn(val, $grades.filter(el => el.class == level)[0].limitNumber, precision);
                break;
                case 'lt':
                    val = this.isFloat ? parseFloat(eval_exp(val)) - (1 / Math.pow(10, precision - 1)) : parseInt(eval_exp(val)) - 1;
                    res = $functions.rn(0, val, precision);
                break;
                case 'bt':
                    let tab = val.split("||").replaceVals(/,|/g, ''), v = $functions.rn(tab[0], tab[1], precision);
                    tab = tab.map(el => eval_exp(el));
                    res = $functions.rn(tab[0], tab[1], precision);
                break;
                case 'in':
                    res = val.split('||').getRand();
                break;
                case 'max':
                    res = Math.max(...val.split('||').filterInt().map(el => eval_exp(el)));
                break;
                case 'min':
                    res = Math.min(...val.split('||').filterInt().map(el => eval_exp(el)));
                break;
                case 'letter':
                    // let evaluated = this.evaluate_int(val)
                    // log ('letter a value:', val, 'evaluated:', evaluated, 'res:', writtenNumber(this.evaluate_int(val)));
                    // res = writtenNumber(this.evaluate_int(val));
                    res = $operations.numberToWord(this.evaluate_int(val));
                break;
                case 'itr':
                    res = $operations.intToRoman(this.evaluate_int(val));
                break;
                case 'rti':
                    res = $operations.romanToInt(this.evaluate_int(val));
                break;
                case 'twrdl':
                    res = converter.toWordsOrdinal(eval_exp(val));
                break;
                case 'estimated':
                    res = val.split('||').map(el => eval_exp(el)).estimated()[0];
                break;
                default:
                    res = eval_exp(val);
                break;
            }
            if(Number(res) == res){
                res = Number(res).toFixed(precision);
            }
        } while (this.isValueValid);
        return res;
    }
    evaluate_fract(cons, deep = 0){
        let rulesObject = cons,
            num_st = rulesObject.indexOf("num(") + 4,
            den_st = rulesObject.indexOf("den(") + 4,
            cons_num = rulesObject.slice(num_st,rulesObject.indexOf(")", num_st)),
            cons_den = rulesObject.slice(den_st,rulesObject.indexOf(")", den_st)), num, den;
        if (cons_den.includes('__$num__')) {
            num = this.evaluate_int(cons_num);
            cons_den = cons_den.replace(/__\$num__/g, num);
            den = this.evaluate_int(cons_den);
        } else if (cons_num.includes('__$den__')) {
            den = this.evaluate_int(cons_den);
            cons_num = cons_num.replace(/__\$den__/g, num);
            num = this.evaluate_int(cons_num);
        } else {
            num = this.evaluate_int(cons_num);
            den = this.evaluate_int(cons_den);
        }

        if (num > den && num % den == 0 && deep <= 10) {
            num += 1;
        }

        return new Fraction( {num: num, den: den});
    }
    evaluate_condition(cons){
        let val = cons.slice(0, 5) === 'cond:' ? cons.slice(5) : cons,
            fn = val.slice(0, val.indexOf('(')), content = val.slice(fn.length + 1, -1);
        switch (fn) {
            case 'if':
                let cond = content.slice(0, content.indexOf('||')),
                    v1 = content.slice(cond.length + 2, content.indexOf('||', cond.length + 2)),
                    v2 = content.slice(cond.length + v1.length + 4);
                return this.evaluate_if(cond) ? this.evaluate_condition(v1) : this.evaluate_condition(v2);
                break;
            default:
                // log('evaluate_condition:', cons, 'function is:', fn, 'val is:', val, 'content is:', content, 'result:', eval_exp(val));
                return eval_exp(val);
                break;
        }
    }
    evaluate_if(val){
        if(!(joiners.map(el => val.includes(el)).reduce((a, b) => a || b, false))){
            if(!(comparators_values.map(el => val.includes(el)).reduce((a, b) => a || b, false))){
                if(val === false || val.length < 1 || val === undefined){
                    return false;
                } else {
                    return true;
                }
            }else{
                for (const comp of comparators_values) {
                    let elts = val.split(comp).slice(0, 2).map(el => eval_exp(el)), isFraction = elts.map(el => $functions.is_fraction(el)).reduce((a, b) => a || b, false);
                    if(isFraction){
                        elts = elts.map(el => new Fraction(el).floatVal);
                    }
                    if(elts.length > 1){
                        switch (comp) {
                            case comparators.lt.val: return elts[0] < elts[1]; break;
                            case comparators.gt.val: return elts[0] > elts[1]; break;
                            case comparators.lte.val: return elts[0] <= elts[1]; break;
                            case comparators.gte.val: return elts[0] >= elts[1]; break;
                            case comparators.df.val: return elts[0] != elts[1]; break;
                            case comparators.eq.val: return elts[0] == elts[1]; break;
                            case '===': return elts[0] === elts[1]; break;
                            default:
                                return false;
                            break;
                        }
                    }
                }
            }
        }
        for (const el of joiners) {
            let vals = val.split(el);
            if(vals.length > 1){
                switch (el) {
                    case '&&': return this.evaluate_if(vals[0]) && this.evaluate_if(vals[1]); break;
                    case '||': return this.evaluate_if(vals[0]) || this.evaluate_if(vals[1]); break;
                    case '^': return this.evaluate_if(vals[0]) ^ this.evaluate_if(vals[1]); break;
                    default:
                        return this.evaluate_if(vals[0]) && this.evaluate_if(vals[1]);
                    break;
                }
            }
        }
    }
    get val(){
        let val;
        if (this.hasOwnProperty('value')) {
            val = this.value;
        } else {
            val = this.calculate_val(this.level);
        }

        if(this.hasOwnProperty('diff') && this.diff != null) {
            // log('variable has diff prperty with value:', this.diff);
            let diffs = this.diff.split('||').map(el => el.toString());
            while(diffs.includes(val.toString())){
                val = this.calculate_val(this.level);
            }
        } else {
            // log('variable has not diff property variable:', this);
        }
        return val;
    }

    get isValueValid() {
        if (this.hasOwnProperty('value')) {
            let verifies = [], i = 0, value = this.value;
            for (let obj in this.rulesObject) {
                verifies[i] = ruleVariable.check(this.rulesObject, obj.key, value)
                i++;
            }
            return verifies.reduce((a, b) => a && b, true);
        }
        return false;
    }
};
class Operation{
    constructor(oper){
        let operation = Object.assign({operator: '', operands: [], exp: '', lbl: "", display: true, result: undefined}, oper);

        if(operation.lbl.trim().length < 1){
            console.warn('Label of operation is not valid:',oper);
        }
        if(!$operators.checkOp_sign(operation.operator)){
            // console.error("Invalid operator for operation:", operation);
            throw new Error(operation.operator + " is an invalid operator for operation");
        }
        if (operation.exp == null) operation.exp = '';

        for (let prop in operation) {
            this[prop] = operation[prop];
        }

        if(!this.hasOwnProperty('pure')){
            this.pure = Object.assign(operation);
        }

        if(this.exp != null && this.exp.trim().length > 0 && this.exp.includes(' = ')){
            let exp = this.exp.substring(0, this.exp.indexOf(' = '));
            this.exp = this.exp.replace(exp,$functions.tag('strong',exp));
            this.operands = this.operands.map(elt=>{
                if($functions.is_fraction(elt) || (typeof elt === 'string' && elt.includes('__fract:'))){
                    this.fract = true;
                    elt = new Fraction(elt);
                }
                return elt;
            });
        }
        // this.result = this.calculate();
    }

    calculate() {
        if (this.hasOwnProperty("result") && this.result != null) {
            // console.log('operation has result:', this.result);
            return this.result;
        } else {
            let arr = [], fraction = false;
            arr = this.operands.map(elt => {
                if (elt instanceof Object) {
                    if(elt.hasOwnProperty("ref")){
                        // elt=this.calculate(this.filter(el=>el.lbl == elt.ref)[0])
                    } else if ($functions.is_fraction(elt)){
                        fraction = true;
                    }
                } else {
                }
                return elt;
            });
            if(this.estimated){
                if (this.isFloat) {
                    arr = arr.map(n => n.toFixed());
                }
                else {
                    arr = arr.estimated();
                }
            }
            let res = $operations.unknow(this.operator, arr);
            console.log('calculating result of operation, res:', res, 'arr', arr, 'operator:', this.operator);
            res = $functions.is_fraction(res)
                || this.isFloat
                || this.floating > 0
                || !$operators.checkOp_IntRes(this.operator)
                || $operators.checkOp_unknow('sub_sent', this.operator)
                || $operators.checkOp_unknow('itr', this.operator)
                || $operators.checkOp_unknow('ntw', this.operator)
                || $operators.checkOp_unknow('add_sent', this.operator)
                || ['object', 'array'].includes(typeof res) ? res : parseInt(res);
            if(this.floating > 0){
                res = Number(Number(res).toFixed(this.floating));
            }
            console.log('Result of operation, res:', res);
            this.result = res;
            return res;
        }
    }

    replace() {
        this.exp = this.exp.replace(this.opreg, this.tag_val);
        this.operands = this.operands.map(oprd=>{
            if(oprd === '__op:' + this.lbl + '__'){
                let v = this.answerOperation
                oprd = this.res_val;
            }
            return oprd;
        });
    }

    get answerOperation () {
        return this.calculate();
    }

    get opreg () {
        return new RegExp('__op:'+this.lbl + "__",'g');
    }

    get tag_val () {
        let value = this.answerOperation, tag_val;
        if($functions.is_fraction(value)){
            let fract = new Fraction(value);
            tag_val = fract.toString();
        } else {
            let val = value;
            if(Number(value) == value){
                val = $functions.read_notation(val);
            }
            tag_val = $functions.tag('span', val, {class: 'oper'});
        }
    }

    get res_val () {
        if($functions.is_fraction(this.answerOperation)){
            return new Fraction(this.answerOperation).simplificated;
        }else{
            return this.answerOperation;
        }
    }

    get res_tag () {
        let res = (!['array','object'].includes(typeof this.answerOperation)) && Number(this.answerOperation) == this.answerOperation ?
            $functions.read_notation(this.answerOperation) : this.answerOperation;

        return res.toString();
    }
}

export default class Quiz{
    constructor(q, level, is_practice = true) {
        let quiz = Object.assign({
            note: "",
            units: "",
            problem: "",
            solution: "",
            type_answer: "",
            transform_answer: "",
            vars: [],
            comments: [],
            explains: [],
            operations: [],
            propositions: [],
            answer_model: ''
        }, q);
        if(!quiz.hasOwnProperty('type_answer')){
            quiz.type_answer = 'int';
        } else if(quiz.transform_answer == '' && quiz.hasOwnProperty('enum_transform_answer')) {
            // $functions.isValidOnlyExcept($variables.transform_answer_tab(quiz.transform_answer), quiz.type_answer)
            quiz.transform_answer = quiz.enum_transform_answer[0];
        }
        this.quiz = Object.assign({}, {...quiz});

        for (let prop in quiz) {
            this[prop] = quiz[prop];
        }
        this.transform_answer = this.transform_answer /*|| (quiz.enum_transform_answer && quiz.constructor.name == 'Array' ? q.enum_transform_answer[0] : "")*/;
        this.level = level;
        this.values = [];

        this.operations = this.operations.map(el => new Operation(el));
        this.setVars();

        if(!this.resultOperation || this.resultOperation == undefined){
            if(is_practice){
                throw new Error("Error on problem:'You must provide an operation with label result'");
            }
            console.warn("No operation with label 'result' not found");
        }

        if (this.type_answer == '') {
            this.type_answer = 'int';
        }
        if (this.answer_model == '') {
            let model = undefined;
            if ($operators.checkOp_unknow('add_sent', this.resultOperation.operator)) {
                model = 'a + b = c';
            } else if ($operators.checkOp_unknow('sub_sent', this.resultOperation.operator)) {
                model = 'a - b = c';
                // log('operation is subtraction sentence, res:', this.resultOperation.answerOperation);
            }
            this.answer_model = model;
        }

        this.solution = ponctuate(this.solution);
        this.explains = this.explains.map(explain => ponctuate(explain));
        this.operations = this.operations.map(operation => {
            let  op = operation;
            op.exp = ponctuate(op.exp);
            return op;
        });
        if (this.type_answer == 'radio') {
            this.propositions = this.propositions.sort((a, b) => Math.random() - 0.5);
        }
    }

    setVars(){
        this.vars = this.vars.map(elt => {
            let vable = new Variable(elt, this.level), val = vable.val;
            this.values.push({ varName: elt.varName, value: val });
            this.replaceVar(vable);
            return vable;
        });

        let vars = this.problem.split(/#__/g);
        if (vars.length > 1) {
            for (let i = vars.length - 1; i >= 0; i--) {
                let str = `__${vars[i]}`,
                    index = this.problem.indexOf('str') + 2,
                    key = this.problem.slice(index, this.problem.indexOf('__', index)),
                    props, j = key.indexOf('@');
                if (j > -1) {
                    props = key.slice(j).split(',').map(prop => prop.split(':')).reduce((obj, prop) => obj[prop[0]] = prop[1], {});
                }
                let vable = new Variable({varName: key, ...props});
                this.values.push({varName: vable.varName, value: vable.val});
                this.vars.push(vable);
                this.replaceVar(vable);
            }
        }

        let i = 0, n = this.problem.split('_').length;
        while (this.problem.includes('__') && i <= n) {
            let index = this.problem.indexOf('__') + 2,
                strVariable = this.problem.slice(index, this.problem.indexOf('__', index + 1)), cons = strVariable.slice(2, -2), name = strVariable,
                props = {}, vable;
            // log ("making variable with string inn problem, str:", strVariable, 'cons:', cons, 'index:', index, 'i:', i, 'n:', n);
            if (strVariable.includes('@')) {
                name = strVariable.slice(0, strVariable.indexOf('@'));
                props = strVariable.slice(strVariable.indexOf('@') + 1).split(',').reduce((obj, prop) => {
                    let p = prop.slice(0, prop.indexOf(':'));
                    obj[p] = prop.slice(prop.indexOf(':') + 1);
                    return obj;
                }, {})
            }
            vable = new Variable({varName: name.replace(/[^\w\s]| /gi, ''), ...props});
            this.values.push({varName: vable.varName, value: vable.val });
            this.vars.push(vable);
            this.problem = this.problem.split(strVariable).join(vable.name);
            this.replaceVar(vable);
            i++;
        }

        if (this.operations.length > 0) {
            this.operations = this.operations.map(op => {
                op = op instanceof Operation ? op : new Operation(op);
                this.solution = this.solution.replace(op.opreg, $functions.tag('span', op.res_tag, {class:'font-bold'}));
                this.problem = this.problem.replace(op.opreg, $functions.tag('span', op.res_tag, {class:'font-bold'}));
                this.operations = this.operations.map(oper => {
                    oper.exp = oper.exp.replace(op.opreg, op.tag_val);
                    oper.operands = oper.operands.map(oprd=>{
                        if(oprd === '__op:' + op.lbl + '__'){
                            let v = op.answerOperation
                            oprd = op.res_val;
                        }
                        return oprd;
                    });
                    return oper;
                });
                return op;
            });

            let sol = this.resultOperation.answerOperation, val;

            if ($functions.is_fraction(sol)) {
                val = sol.intFractionNotation;
            } else if (sol instanceof Array) {
                val = sol.getRand();
            } else {
                val = Number(sol) == sol ? $functions.read_notation(sol) : sol;
            }
            // log('setVars of:', this, 'variables:', this.vars, "values:", this.values, "operations:", this.operations, 'sol:', sol, 'res:', val);
            this.solution = this.solution.replace(/__result__/gi, $functions.tag('span', val, { class: 'result' }));
        }
    }

    calculate(operation) {
        if (operation.hasOwnProperty("result") && operation.result != undefined) {
            return operation.result;
        } else {
            let arr = [], fraction = false;

            arr = operation.operands.map(elt => {
                if(elt instanceof Object){
                    if(elt.hasOwnProperty("ref")){
                        elt = this.calculate(this.operations.filter(el => el.lbl == elt.ref)[0])
                    }else if($functions.is_fraction(elt)){
                        fraction = true;
                    }
                }else{
                }
                return elt;
            });
            if (operation.estimated) {
                arr = arr.estimated();
            }
            let res;
            switch (operation.operator) {
                case '/':
                    res = $operations.division(...arr, operation.floating)
                    break;
                default:
                    res = $operations.unknow(operation.operator, arr);
                    break;
            }
            this.operations.filter(el => el.lbl == operation.lbl)[0].result = res;
            res = $functions.is_fraction(res) || operation.isFloat || operation.floating > 0 || ['object', 'array'].includes(typeof res) ? res : parseInt(res);
            if (operation.floating > 0) {
                res = Number(res).toFixed(operation.floating);
            }
            return res;
        }
    }

    replaceVar(variable) {
        let key_var = variable.name,
            value = variable.val,
            reg = new RegExp("__" + key_var + "__", "gi"),
            reg_ = new RegExp("&__" + key_var + "__&", "gi"),
            // Replace these by exact value without any tag. Suitable for other variables within problems
            reg_v = new RegExp("__" + key_var + ":v__", "gi"),
            reg_fract_m, val_mixed, reg_fract_s, val_simplified,
            tag_val, val = value;
        if($functions.is_fraction(value)){
            // log('value of variable', variable, 'is fraction with value:', value);
            let fract = new Fraction(value);
            tag_val = fract/*"<fraction :fraction='"+JSON.stringify(value)+"'></fraction>"*/;
            val = fract.string();
            reg_fract_m = new RegExp('__' + key_var + ':m__','gi');
            reg_fract_s = new RegExp('__' + key_var + ':s__','gi');
            val_mixed = fract.intFractionNotation;
            val_simplified = fract.simplificated;
        } else {
            let v = value;
            val = value;
            if(Number(value) == value){
                v = $functions.read_notation(v);
            }
            tag_val = $functions.tag('span', v, {class: `${variable.type} variable`});
        }
        if($functions.is_fraction(val)){
            let fract = new Fraction(val);
            this.problem = this.problem.replace(reg_, `&${fract.string()}&`);
            this.problem = this.problem.replace(reg_fract_m, val_mixed);
            this.explains = this.explains.replaceVals(reg_fract_m, val_mixed);
            this.problem = this.problem.replace(reg_fract_s, val_mixed);
            this.explains = this.explains.replaceVals(reg_fract_s, val_simplified);
        }else{
            this.problem = this.problem.replace(reg_, `&${val}&`);
        }
        this.problem = this.problem.replace(reg_v, value);
        this.problem = this.problem.replace(reg, tag_val);
        this.explains = this.explains.replaceVals(reg_v, value);
        this.explains = this.explains.replaceVals(reg, tag_val);
        this.units = (this.units || '').replace(reg, tag_val);
        this.solution = this.solution.replace(reg, tag_val);
        this.solution = this.solution.replace(reg_fract_m, val_mixed);

        for (const obj of this.vars.filter(el=>el.varName !== key_var)) {
            for (const key in obj) {
                if(obj[key] != null && obj[key].isFraction){
                    let f = obj[key];
                    obj[key] = new Fraction({num:f.num.replace(reg,val), den:f.den.replace(reg,val)});
                }
                if(typeof val === 'object' && typeof obj[key] == 'string'){
                    if($functions.is_fraction(val)){
                        obj[key] = obj[key].replace(reg,val.string());
                    }
                }
                if(['string','number'].includes(typeof val) && typeof obj[key] == 'string'){
                    obj[key]=obj[key].replace(reg,val);
                }
            }
        }
        switch (this.type_answer) {
            case 'radio':
                for (let obj of this.propositions) {
                    for (const key in obj) {
                        if($functions.is_fraction(obj[key])){
                            let f = obj[key], p = typeof f === 'string' ? f : {num: f.num.replace(reg, val), den: f.den.replace(reg, val)}, fract = new Fraction(p);
                            obj[key] = obj[key].replace(reg, fract.string());
                            // log(key, 'in', obj, 'is a fraction', 'replace', reg, 'by', fract.string(), 'result:', obj[key]);
                        }
                        if(typeof val == 'object' && typeof obj[key] == 'string'){
                            if($functions.is_fraction(val)){
                                obj[key] = obj[key].replace(reg, val.string());
                                // log(val, 'is an object(fraction) and', obj[key], 'is a string. key:', key, 'obj:', obj);
                            }
                        }
                        if(typeof obj[key] == 'string' && ['string', 'number'].includes(typeof val)){
                            obj[key] = obj[key].replace(reg, val);
                            // log(val, 'is an object(fraction) and', obj[key], 'is a string. key:' key, 'objj:', obj);
                        }
                    }
                }
            break;
            default:
                break;
        }

        this.operations = this.operations.map(el => {
            el.exp = el.exp.replace(reg, tag_val);
            el.exp = el.exp.replace(reg_fract_m, val_mixed);
            el.operands = el.operands.map(elt => {
                if ($functions.is_fraction(val) && elt === `__fract:${key_var}__`) {
                    elt = new Fraction(val);
                } else if (elt === `__${key_var}__`){
                    elt = val;
                }
                return elt;
            });
            el.result = typeof el.result == 'string' ? el.result.replace(reg, val) : el.result;
            return el;
        });
    }
    get resultOperation() {
        return this.operations.filter(el => el.lbl == 'result').pop() || this.operations[this.operations.length - 1];
    }
    get answerFraction() {
        return this.type_answer == 'fraction' || ($functions.is_fraction(this.resultOperation.answerOperation) && !['radio'].includes(this.type_answer));
    }

    get answerQuiz() {
        return this.resultOperation.answerOperation;
    }

    get isValid() {
        return this.operations.filter(operation => operation.lbl == 'result').length === 1;
    }
};

export { Variable, Operation };
function eval_exp(exp = "", id_practice =- 1){
    let scape = { end: $variables.escapeString.end, start: $variables.escapeString.start }, indexStartScape = exp.indexOf(scape.start);
    if (indexStartScape > -1) {
        let indexEndScape = exp.indexOf(scape.end),
            startString = exp.slice(0, indexStartScape),
            escapedString = exp.slice(indexStartScape + scape.start.length, indexEndScape/*(indexEndScape == -1 ? exp.length : indexEndScape)*/),
            endString = exp.slice(indexEndScape + scape.end.length);
        // log('scaped string:', exp, 'start escape at:', indexEndScape, 'first part:', startString, 'escaped string:', escapedString, 'end of string:', endString);
        return eval_exp(startString) + escapedString + eval_exp(endString);
    }
    // log("eval_exp with exp:", exp);
    if (exp.trim().length == 0) {
        return exp;
    }
    if(exp.includes('(')){
        let tab = exp.trim().split('(').map((el, i) => i == 0 ? el : '(' + el);
        for (let i = 0; i < tab.length - 1; i++) {
            if(!signs.times.slpit(',').includes(tab[i].slice(-1))){
                tab[i] += '*';
            }
        }
        let exp_oper_tab = tab, stack = tab.join(''), k = 1;

        let err = new Error("Closed bracket without opened");

        if(exp_oper_tab[0].includes(')')){
            // axios.post(route('error.store'),{property:"pracctices",id_property:id_practice,description:"Closed bracket without opened"});
            throw err;
        }

        for(let i = 0; i < exp_oper_tab.length; i++){
            let el = exp_oper_tab[i].trim(), j = i - k ;

            while (el.includes(')')) {
                let prev = exp_oper_tab[j].trim();

                if(!el.includes('(')){
                    throw err;
                    return;
                }

                let operator = prev.charAt(prev.length - 2), operation = el.slice(el.indexOf('(') + 1, el.indexOf(')')), res = eval_exp(operation);
                el = prev + el.replace('(' + operation + ')', res);
                stack = stack.replace('(' + operation + ')', res);
                j = j - 1;
                k++;
            }
        }
        if(stack.includes('(')&&!stack.includes(')')){
            throw err;
        }
        return eval_exp(stack);
    }else{
        let operators = ["+", "-", "*", "/", "%", ">", "<" /*,"<<",">>"*/];
        /*
         * +
         * -
         * *
         * /
         * >  >, gcf, pgcd,
         * <  <, lcm, ppcm,
         */
        if(Number(exp) == exp){
            return Number(exp);
        }
        if(!(operators.map(el => exp.includes(el)).reduce((a, b) => a || b, false))){
            return exp;
        }
        for(let i = 0; i < operators.length; i++){
            let op = operators[i];
            if(exp.split(op).length > 1){
                let tab = exp.split(op).map(el => eval_exp(el)), res = $operations.unknow(op, tab);
                return res;
            }
        }
    }
}

function ponctuate(txt) {
    let text = txt, tab_ponctuation = ['.', '!', ';'];
    if (text.length > 10) {
        if (!tab_ponctuation.includes(text.slice(-1))){
            text += '.';
        }
    }
    return text;
}